import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl } from "@angular/forms";
import { Router } from "@angular/router";

import { LoadingBarService } from "@ngx-loading-bar/core";

import Swal from "sweetalert2";

import { HeaderService, ServiceProvidersService } from "../../../shared";

@Component({
  selector: "app-service-providers-new",
  templateUrl: "./service-providers-new.component.html",
  styleUrls: ["./service-providers-new.component.scss"]
})
export class ServiceProvidersNewComponent implements OnInit {
  title = "NOVO PRESTADOR DE SERVIÇO";
  subtitle =
    "Utilize os campos abaixo para cadastrar um novo prestador de serviço";
  urlBack = "/panel/service-providers/list";

  maskCnpj = "00.000.000/0000-00";

  newServiceProvider = new FormGroup({
    nmRazaoSocial: new FormControl(""),
    nrCnpj: new FormControl(""),
    nmFantasia: new FormControl(""),
    nrInscrEstadual: new FormControl(""),
    servicos: new FormControl([]),
    regioes: new FormControl([]),
    estados: new FormControl([]),
    areas: new FormControl(""),
    cdFornecedorSap: new FormControl("")
  });

  selectedRegions = [];
  selectedStates = [];
  checkboxActive = [];
  relationships = [
    {
      cdArea: [],
      dsArea: [],
      equipamentos: []
    }
  ];

  constructor(
    private headerService: HeaderService,
    private serviceProvidersService: ServiceProvidersService,
    private loadingBarService: LoadingBarService,
    private router: Router
  ) {}

  ngOnInit() {
    this.headerService.changeTitle("Cadastro de novo prestador de serviço");

    this.headerService.changeSubtitle("");

    this.headerService.changeDatePicker(false);
  }

  serviceValues(arr: Array<any>) {
    this.newServiceProvider.patchValue({
      servicos: arr
    });

    this.checkboxActive = arr;
  }

  regionsValues(arr: Array<any>) {
    this.newServiceProvider.patchValue({
      regioes: arr
    });
  }

  statesValues(arr: Array<any>) {
    this.newServiceProvider.patchValue({
      estados: arr
    });
  }

  relationshipsValues(arr: Array<any>) {
    this.newServiceProvider.patchValue({
      areas: arr
    });
  }

  resetValues() {
    this.newServiceProvider.patchValue({
      servicos: "",
      regioes: [],
      estados: [],
      equipamentos: ""
    });

    this.selectedRegions = [];

    this.selectedStates = [];

    this.checkboxActive = [];

    this.relationships = [
      {
        cdArea: [],
        dsArea: [],
        equipamentos: []
      }
    ];
  }

  addNewServiceProvider() {
    this.loadingBarService.start();

    if (this.newServiceProvider.controls.nrInscrEstadual.value == "") {
      this.newServiceProvider.patchValue({
        nrInscrEstadual: "0"
      });
    }

    this.serviceProvidersService
      .addServiceProvider(this.newServiceProvider.value)
      .subscribe(response => {
        this.loadingBarService.complete();

        this.newServiceProvider.reset();

        this.resetValues();

        Swal({
          type: "success",
          title: "Prestador de serviço cadastrado",
          text: "O prestador de serviço será exibido na listagem",
          confirmButtonText: "Ok, entendi!",
          confirmButtonClass: "sweet-button",
          buttonsStyling: false
        }).then(result => {
          this.router.navigate([this.urlBack]);
        });
      });
  }
}
